<nz-card>
  <h1>{{ 'ADMIN.SEATS_RBAC.TITLE' | translate }}</h1>

  <h2>{{ 'ADMIN.SEATS_RBAC.PLAN_DEFAULTS' | translate }}</h2>
  <nz-table [nzData]="plans" [nzPageSize]="5">
    <thead>
    <tr>
      <th>{{ 'ADMIN.SEATS_RBAC.PLAN' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.DEFAULT_MAX_USERS' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let plan of plans">
      <td>{{ ('PLAN.' + (plan.planKey || 'free').toUpperCase()) | translate }}</td>
      <td><input nz-input type="number" [(ngModel)]="plan.defaultMaxUsers" /></td>
      <td><button nz-button nzType="primary" (click)="savePlan(plan)">{{ 'ADMIN.SEATS_RBAC.SAVE' | translate }}</button></td>
    </tr>
    </tbody>
  </nz-table>

  <h2>{{ 'ADMIN.SEATS_RBAC.COMPANY_OVERRIDES' | translate }}</h2>
  <input nz-input [(ngModel)]="search" [placeholder]="'ADMIN.SEATS_RBAC.SEARCH' | translate" />

  <nz-table [nzData]="filteredCompanies" [nzLoading]="loading" [nzPageSize]="10">
    <thead>
    <tr>
      <th>{{ 'ADMIN.SEATS_RBAC.COMPANY' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.PLAN' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.SEATS_USED_MAX' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.SEAT_LIMIT_OVERRIDE' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.SEAT_ENFORCEMENT' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.SSO_AUTO_JOIN' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.ALLOWED_DOMAINS' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.ALLOWED_TENANTS' | translate }}</th>
      <th>{{ 'ADMIN.SEATS_RBAC.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let company of filteredCompanies">
      <td>{{ company.name }}<br /><small>{{ company.domain }}</small></td>
      <td>{{ ('PLAN.' + (company.plan || 'free').toUpperCase()) | translate }}</td>
      <td>{{ company.seatsUsed }} / {{ company.effectiveSeatLimit ?? '∞' }}</td>
      <td><input nz-input type="number" [(ngModel)]="company.seatLimit" /></td>
      <td><nz-switch [(ngModel)]="company.seatEnforcementEnabled"></nz-switch></td>
      <td><nz-switch [(ngModel)]="company.ssoAutoJoinEnabled"></nz-switch></td>
      <td><input nz-input [(ngModel)]="company.allowedDomainsText" [placeholder]="'ADMIN.SEATS_RBAC.CSV_PLACEHOLDER' | translate" /></td>
      <td><input nz-input [(ngModel)]="company.allowedTenantIdsText" [placeholder]="'ADMIN.SEATS_RBAC.CSV_PLACEHOLDER' | translate" /></td>
      <td><button nz-button nzType="primary" (click)="saveCompany(company)">{{ 'ADMIN.SEATS_RBAC.SAVE' | translate }}</button></td>
    </tr>
    </tbody>
  </nz-table>
</nz-card>
